'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.channelsUpdated = exports.socketDisconnect = exports.socketConnect = undefined;

var _socketConstants = require('./socketConstants');

var socketConnect = exports.socketConnect = function socketConnect() {
    return { type: _socketConstants.SOCKET_CONNECT };
};
var socketDisconnect = exports.socketDisconnect = function socketDisconnect() {
    return { type: _socketConstants.SOCKET_DISCONNECT };
};

var channelsUpdated = exports.channelsUpdated = function channelsUpdated(_ref) {
    var joined = _ref.joined,
        left = _ref.left,
        boardChannels = _ref.boardChannels;
    return {
        type: _socketConstants.CHANNELS_UPDATED,
        joined: joined,
        left: left,
        boardChannels: boardChannels
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/socket/socketActions.js
// module id = 767
// module chunks = 0